import { render, staticRenderFns } from "./VaxEmployeePage.vue?vue&type=template&id=4e92d600&scoped=true"
import script from "./VaxEmployeePage.vue?vue&type=script&lang=js"
export * from "./VaxEmployeePage.vue?vue&type=script&lang=js"
import style0 from "./VaxEmployeePage.vue?vue&type=style&index=0&id=4e92d600&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e92d600",
  null
  
)

export default component.exports